<template>
<div>
    <h1>Help</h1>

    <v-btn color="primary" fab fixed bottom right href="mailto:GTSCOELeads@LyondellBasell.onmicrosoft.com?subject=UI%20Questions">
        <v-icon>mdi-send</v-icon>
    </v-btn>

    <v-row>
        <v-col cols="12" xs="12" lg="10">
            <v-card width="100%">
                <v-card-title>What is this?</v-card-title>
                <v-card-text>
                    <p>
                        This is your app. There is nothing here yet, but you can use this area to do just about anything you want.
                        Within this space you will find the tools, frameworks and utilities to create a fully functioning application big or small.
                        If by chance you need some advanced functionality you can always go to <a href="https://npmjs.org">npmjs.org</a> and download additional package to get the job done.
                    </p>
                </v-card-text>
            </v-card>
            <br />
            <v-card width="100%">
                <v-card-title>Folder Structure</v-card-title>
                <v-card-text>
                    When you open this in an IDE like Visual Studio Code you will find this basic folder structure:<br />
                    <strong>[Project Root]/src/apps/my-app/</strong>
                    <br />
                    <br />
                    <v-simple-table>
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">
                                    </th>
                                    <th class="text-left">
                                        Name
                                    </th>
                                    <th class="text-left">
                                        Description
                                    </th>
                                    <th class="text-left">
                                        Help
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="fld in srcFolders" :key="fld.name">
                                    <td>
                                        <v-icon size="32" :color="fld.iconColor">{{ fld.icon }}</v-icon>
                                    </td>
                                    <td><span class="fld-name">{{ fld.name }}</span></td>
                                    <td>
                                        <p v-html="fld.description" />
                                    </td>
                                    <td>
                                        <v-btn icon color="primary" v-if="!!fld.link" :to="fld.link">
                                            <v-icon>mdi-help</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>

                    <h2>Sample app.config.js</h2>
                    <pre>{{appConfig}}</pre>
                </v-card-text>
            </v-card>
            <br />
            <v-card>
                <v-card-title>What is Material Design and how are we using it?</v-card-title>
                <v-card-text>

                  <p>
                    Material Design is a UI specification created by Google. This technical specification takes most of the guess work out of UI decision making (how buttons should look, how dialogs should behave etc.)
                    If you want to know more about the specification you can reference the official site <a target="_blank" href="https://material.io/design">https://material.io/design</a>
                  </p>
                  <p>
                    This project implements Material Design through a third party component framework called <a href="https://vuetifyjs.com/" target="_blank">Vuetify</a>. Get to know the documentation well since any UI components that we build will probably be made up of one ore more vuetify components.
                  </p>
                </v-card-text>
                <v-card-actions>
                  <v-btn color="primary" href="https://material.io/" target="_blank"><v-icon>mdi-material-design</v-icon> Material Design</v-btn>
                  <v-btn color="primary" href="https://materialdesignicons.com/" target="_blank"><v-icon>mdi-material-ui</v-icon> Material Design Icons</v-btn>
                  <v-btn color="primary" href="https://vuetifyjs.com/" target="_blank"><v-icon>mdi-vuetify</v-icon> Vuetify JS</v-btn>
                </v-card-actions>
            </v-card>
            <br />
            <v-card>
                <v-card-title>What should I do next?</v-card-title>
                <v-card-text>
                    <ol>
                        <li>
                            <p>
                                You can use the <v-btn to="helloworld" color="primary" small>
                                    <v-icon>mdi-hand</v-icon>Hello World
                                </v-btn> page as a sandbox.
                            </p>
                        </li>
                        <li>
                            <p>
                                Play around with each of the folders and get to know what they do and how they work.
                            </p>
                        </li>
                        <li>
                            <p>
                                Browse the sup[port section for examples and video tutorials.
                                <br />
                                <v-btn small color="primary" to="/support">
                                    <v-icon>mdi-school</v-icon> Support
                                </v-btn>
                            </p>
                        </li>
                        <li>
                            <p>
                                If you have any question email the <v-btn color="primary" small href="mailto:GTSCOELeads@LyondellBasell.onmicrosoft.com?subject=UI%20Questions">
                                    <v-icon>mdi-send</v-icon>Email Questions, Comments, Suggestions
                                </v-btn>.
                            </p>
                        </li>
                    </ol>
                </v-card-text>
            </v-card>
            <br />
            <v-card color="secondary" tile elevation-0 dark>
                <v-card-title>
                    <v-icon>mdi-lightbulb-outline</v-icon> Things to know
                </v-card-title>
                <v-card-text>
                    <v-divider />
                    <p>
                        There are many other files and configurations that make this project run. You should not add, modify or delete any file that is not in your project folder.
                        <br />
                        <br />
                        <strong>[Project Root]/src/views/my-app/*</strong>
                    </p>
                    <v-divider />
                    <p>
                        You can always add more packages from the npmjs library but keep in mind that those packages increase your app size (sometimes significantly).
                        This can lead to overall performance loss of your pages.
                    </p>
                    <v-divider />
                </v-card-text>

            </v-card>
        </v-col>
    </v-row>
</div>
</template>

<script>
import moment from "moment"
import appConfig from "@/_config/application-config.js"
import uiView from "@/_mixins/ui-view-mixin"

export default {
    name: 'SamplePage',
    mixins: [uiView],
    created() {},
    props: {},
    watch: {},
    computed: {
        appConfig() {
            return appConfig;
        },

        srcFolders() {
            return [{
                    icon: "mdi-folder",
                    iconColor: "amber",
                    name: "components",
                    description: "A place to put your reusable custom components.  There is even a sample available that you can use as a base (copy paste).",
                    link: "/support/custom-components",
                },
                {
                    icon: "mdi-folder",
                    iconColor: "amber",
                    name: "mixins",
                    description: "Mixins help you to ensure that common functionality can be made available to your components.  They allow components to be many things at once (polymorphism) without some of the restrictions that inheritance brings.",
                    link: "/support/mixins",
                },
                {
                    icon: "mdi-folder",
                    iconColor: "amber",
                    name: "routes",
                    description: "Routes connect urls to components allowing you to define page views.  You can also pass parameters through the route in the url or a querystring which can be made available to you through the this.$route object within your component.",
                    link: "/support/vue-router",
                },
                {
                    icon: "mdi-folder",
                    iconColor: "amber",
                    name: "store",
                    description: "The store is used to define global variables and constructs.  All of the values within the user settings page are stored in global variables such as the preferred way that a user might like to see a date or how they would like their UI configured.",
                    link: "/support/vue-store",
                },
                {
                    icon: "mdi-folder",
                    iconColor: "amber",
                    name: "views",
                    description: "These are your page definitions.  Create as many as you would like as well as substructures of pages.  Remember, a page won't be visible until you define a route for it.",
                    link: "/support/vue-router",
                },
                {
                    icon: "mdi-language-javascript",
                    iconColor: "blue",
                    name: "app.config.js",
                    description: "Your app definition. From here you can add change the name, icon and color of your app as well as configure the top level navigation.",
                    link: null,
                },
                {
                    icon: "mdi-vuejs",
                    iconColor: "green",
                    name: "Application.vue",
                    description: "Your application entrypoint.  Think of this file like you would a master page in the traditional ASP.NET sense.  This gives you a place to add your global controls that should be available on all of your pages.",
                    link: null,
                },
            ];
        }
    },
    data: () => ({

    }),
    methods: {}

}
</script>

<style lang="scss">
p {
    margin: 10px;
}

.fld-name {
    font-size: 1.0em;
    text-transform: uppercase;
    font-weight: bold;
}
</style>
